import Cookies from "js-cookie";

export const handleUnauthorizedError = (error) => {
    if (error.response && error.response.status === 401) {
      Cookies.remove('loginOK');
    }
};